var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-hover",rawName:"v-b-hover",value:(_vm.handleHover),expression:"handleHover"}],staticClass:"clipboard-copy",on:{"click":_vm.copyToClipboard}},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('Transition',{attrs:{"name":"fade"}},[(_vm.isHovered)?_c('i',{staticClass:"far fa-copy m-1"}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }